"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOrientationSessionHoursDto = instanceOfOrientationSessionHoursDto;
exports.OrientationSessionHoursDtoFromJSON = OrientationSessionHoursDtoFromJSON;
exports.OrientationSessionHoursDtoFromJSONTyped = OrientationSessionHoursDtoFromJSONTyped;
exports.OrientationSessionHoursDtoToJSON = OrientationSessionHoursDtoToJSON;
exports.OrientationSessionHoursDtoToJSONTyped = OrientationSessionHoursDtoToJSONTyped;
/**
 * Check if a given object implements the OrientationSessionHoursDto interface.
 */
function instanceOfOrientationSessionHoursDto(value) {
    if (!('orientationSessionId' in value) || value['orientationSessionId'] === undefined)
        return false;
    if (!('minutesWorked' in value) || value['minutesWorked'] === undefined)
        return false;
    if (!('skippedMealBreak' in value) || value['skippedMealBreak'] === undefined)
        return false;
    if (!('didNotWork' in value) || value['didNotWork'] === undefined)
        return false;
    return true;
}
function OrientationSessionHoursDtoFromJSON(json) {
    return OrientationSessionHoursDtoFromJSONTyped(json, false);
}
function OrientationSessionHoursDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orientationSessionId': json['orientationSessionId'],
        'minutesWorked': json['minutesWorked'],
        'skippedMealBreak': json['skippedMealBreak'],
        'didNotWork': json['didNotWork'],
    };
}
function OrientationSessionHoursDtoToJSON(json) {
    return OrientationSessionHoursDtoToJSONTyped(json, false);
}
function OrientationSessionHoursDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orientationSessionId': value['orientationSessionId'],
        'minutesWorked': value['minutesWorked'],
        'skippedMealBreak': value['skippedMealBreak'],
        'didNotWork': value['didNotWork'],
    };
}
//# sourceMappingURL=OrientationSessionHoursDto.js.map